import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiConfigService } from '../services/api';
import '../styles/Navbar.css';

const Navbar = () => {
  const [logoUrl, setLogoUrl] = useState(null);
  const { user, logout, isAdminOrDiretor } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Carregar logo quando o componente montar
    const url = apiConfigService.getLogoUrl();
    setLogoUrl(`${url}?t=${Date.now()}`);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          {logoUrl ? (
            <img 
              src={logoUrl} 
              alt="Logo" 
              className="navbar-logo-img"
              onError={() => setLogoUrl(null)}
            />
          ) : (
            <>
              <h2>DVS TELECOM</h2>
              <span className="navbar-subtitle">CRM</span>
            </>
          )}
        </div>

        <div className="navbar-menu">
          <Link to="/dashboard" className={`nav-link ${isActive('/dashboard')}`}>
            🏠 Dashboard
          </Link>
          
          <Link to="/vendas" className={`nav-link ${isActive('/vendas')}`}>
            📊 Vendas
          </Link>
          
          <Link to="/catalogo-planos" className={`nav-link ${isActive('/catalogo-planos')}`}>
            📦 Catálogo de Planos
          </Link>
          
          {user && user.role !== 'backoffice' && user.role !== 'supervisor_bko' && (
            <Link to="/vendas/consulta-viabilidade" className={`nav-link ${isActive('/vendas/consulta-viabilidade')}`}>
              ➕ Nova Venda
            </Link>
          )}
          
          {(isAdminOrDiretor() || user?.role === 'backoffice' || user?.role === 'supervisor_bko') && (
            <Link to="/fila-tratamento" className={`nav-link ${isActive('/fila-tratamento')}`}>
              📋 Fila de Tratamento
            </Link>
          )}
          
          {isAdminOrDiretor() && (
            <Link to="/vendas-pagamento" className={`nav-link ${isActive('/vendas-pagamento')}`}>
              💰 Controle de Pagamentos
            </Link>
          )}
        </div>

        <div className="navbar-user">
          <div className="user-info">
            <span className="user-name">{user?.nome}</span>
            <span className="user-role">{user?.role?.toUpperCase()}</span>
          </div>
          <button onClick={handleLogout} className="btn-logout">
            🚪 Sair
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
